import { render, staticRenderFns } from "./TopSliderComponent.vue?vue&type=template&id=14c4453b&scoped=true&"
import script from "./TopSliderComponent.vue?vue&type=script&lang=js&"
export * from "./TopSliderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4453b",
  null
  
)

export default component.exports